import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { OrdemServico } from '@/types/ordemServico';

/** Travessão usado como fallback visual para campos vazios nas listas de OS. */
export const EMPTY_LABEL = '—';

/** Data agendada formatada (pt). `EMPTY_LABEL` quando ausente. */
export function formatarDataAgendada(data?: string | null): string {
  if (!data) return EMPTY_LABEL;
  return format(new Date(data), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

/** Primeira letra (maiúscula) do nome, para avatar de iniciais. */
export function inicialNome(nome?: string | null): string {
  return nome?.trim().charAt(0).toUpperCase() || '?';
}

/**
 * Rótulo dos serviços de uma OS: usa `descricao`, ou `tipo` quando não é UUID,
 * juntos por vírgula. `fallback` quando vazio (o chamador passa a string traduzida).
 */
export function servicosLabel(os: OrdemServico, fallback: string): string {
  return (
    (os.servicos || [])
      .map((s) => {
        if (s.descricao && s.descricao.trim() !== '') return s.descricao;
        if (s.tipo && !/^[a-f0-9-]{36}$/i.test(s.tipo)) return s.tipo;
        return null;
      })
      .filter(Boolean)
      .join(', ') || fallback
  );
}
